import clsx from 'clsx';
import { SalesforceProductSpecialPrice } from '~/lib/salesforce/types';
import { useSpecialPrice } from '~/services/special-price';
import { SplashProps } from '~/shared/components/ProductCard/components/Splash';
import { TProductDetails } from '~/shared/components/ProductCard/ProductCard.definition';
import styles from './ProductSplash.module.scss';

interface BaseProductSplashProps {
    id: string;
    splash: SplashProps | undefined;
    specialPrices: SalesforceProductSpecialPrice | undefined;
}

export type ProductSplashProps = BaseProductSplashProps &
    React.HTMLAttributes<HTMLDivElement> & {
        size?: 'large' | 'regular' | 'small';
        background?: 'white' | 'grey' | 'transparent';
    };

export const extractProductSplash = (product: TProductDetails): BaseProductSplashProps => ({
    id: product.id,
    splash: product.splash,
    specialPrices: product.cust_specialPrices,
});

export const ProductSplash: React.FC<ProductSplashProps> = ({
    className,
    id,
    splash,
    specialPrices,
    background = 'grey',
    size = 'regular',
    ...rest
}) => {
    const { splash: specialPriceSplash } = useSpecialPrice({
        id,
        c_specialPrices: specialPrices,
    });

    // Special pricing campaign callouts will take priority over other callouts.
    const splashText = specialPriceSplash || splash?.text;

    const shouldShowSplashText = !!splashText;

    if (!shouldShowSplashText) return null;

    return (
        <div className={clsx(styles.splash, styles[background], styles[size], className)} {...rest}>
            <span className={styles.text}>{splashText}</span>
        </div>
    );
};
